import { motion } from "./";
export const MotionDiv = motion.div;
//# sourceMappingURL=size.js.map